export default "__VITE_ASSET__efb943e3__"